<template>
    <div id="hk-mask-popup" v-show="show">
        <slot></slot>
    </div>
</template>
<script>
export default {
    data() {
        return {
            show: false
        }
    },
    methods: {
        open() {
            this.show = true;
        },
        close() {
            this.show = false;
        }
    }

}
</script>
<style>
#hk-mask-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .7);
    z-index: 1000;
}
</style>